var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 56,
    viewBox: "0 0 51 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7536 28L37.7831 16.9872C38.0734 16.6572 38.234 16.2151 38.2304 15.7563C38.2268 15.2974 38.0592 14.8585 37.7637 14.534C37.4682 14.2096 37.0684 14.0255 36.6506 14.0216C36.2327 14.0176 35.8301 14.194 35.5295 14.5127L25.5001 25.5255L15.4706 14.5127C15.17 14.194 14.7674 14.0176 14.3495 14.0216C13.9317 14.0255 13.5319 14.2096 13.2364 14.534C12.9409 14.8585 12.7733 15.2974 12.7697 15.7563C12.7661 16.2151 12.9267 16.6572 13.217 16.9872L23.2465 28L13.217 39.0127C13.0648 39.1742 12.9434 39.3673 12.8599 39.5808C12.7763 39.7943 12.7324 40.0239 12.7305 40.2563C12.7287 40.4886 12.769 40.7191 12.8492 40.9341C12.9293 41.1492 13.0476 41.3446 13.1973 41.5089C13.3469 41.6732 13.5249 41.8032 13.7207 41.8912C13.9166 41.9792 14.1264 42.0234 14.3381 42.0214C14.5497 42.0194 14.7588 41.9711 14.9533 41.8794C15.1477 41.7877 15.3236 41.6544 15.4706 41.4872L25.5001 30.4745L35.5295 41.4872C35.8301 41.806 36.2327 41.9824 36.6506 41.9784C37.0684 41.9744 37.4682 41.7904 37.7637 41.4659C38.0592 41.1414 38.2268 40.7025 38.2304 40.2437C38.234 39.7848 38.0734 39.3428 37.7831 39.0127L27.7536 28Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/CloseButton.3c884ab3.svg";
export { ForwardRef as ReactComponent };